import { put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import {
    GET_PHOTOS,
    DELETE_PHOTO,
    GET_PHOTO_FAULTS,
} from '../types/photos';
import {
    getPhotosSuccess,
    getPhotosFail,
    deletePhotoSuccess,
    deletePhotoFails,
    getPhotoFaultsSuccess,
    getPhotoFaultsFail,
} from '../actions/photos';
import {
    getFlights
} from '../actions/flightManager';

export function* getPhotosSaga(action) {
    try {
        yield call(delay, 250);
        const { axiosInstance } = action;
        const { data } = yield axiosInstance.get(`projects/${String(action.projectId)}/photos`);
        yield put(getPhotosSuccess(data));
    } catch (error) {
        yield put(getPhotosFail(error));
    }
}

export function* watchGetPhotos() {
    //https://github.com/redux-saga/redux-saga/blob/master/docs/recipes/README.md
    // Debouncing
    yield takeLatest(GET_PHOTOS, getPhotosSaga);
}

export function* getPhotoFaultsSaga(action) {
    try {
        const { axiosInstance } = action;
        const { data } = yield axiosInstance.get(`photos/${action.photoId}/faults`);
        yield put(getPhotoFaultsSuccess(data));
    } catch (error) {
        yield put(getPhotoFaultsFail(error));
    }
}

export function* watchGetPhotoFaults() {
    yield takeEvery(GET_PHOTO_FAULTS, getPhotoFaultsSaga);
}

export function* deletePhotoSaga(action) {
    try {
        const { axiosInstance } = action;
        yield axiosInstance.request(
            {
                url: `photos/${String(action.photoId)}`,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        // to refresh flight photo number
        yield put(getFlights(axiosInstance));
        yield put(deletePhotoSuccess(action.photoId));
    }
    catch (error) {
        yield put(deletePhotoFails(error));
    }
}

export function* watchDeletePhotos() {
    yield takeEvery(DELETE_PHOTO, deletePhotoSaga);
}


// WEBPACK FOOTER //
// ./src/sagas/photos.jsx